module.exports = __webpack_public_path__ + "img/x.cc8f9aa2.svg";